import { useNavigate } from 'react-router-dom'
import { faPlain } from 'utilities/helper/format'
import { PLAN_SUBSCRIPTION } from 'pages/fund/buySubscription/utils'

/** How early the box page starts warning. Managers only find out the fund's
 *  package lapsed when a feature stops working, so the warning needs a
 *  comfortable window to pay in — not the last few days.
 *
 *  This is a nag threshold, NOT a gate: renewal is available from the plans
 *  page at any time, however long is left on the subscription. */
const WARN_FROM_DAYS = 20

export default function ExpiryNotice({
    moneyPoolId,
    servicePackage,
    remainingDays,
    isManager,
}: {
    moneyPoolId?: string
    servicePackage?: number
    /** Backend returns 0 when no paid order is live, null for «never had one». */
    remainingDays?: number | null
    isManager: boolean
}) {
    const navigate = useNavigate()

    // Only a manager can pay, and only a fund actually ON the subscription tier
    // has something to renew. Once the order lapses the backend reports the
    // free package, so this notice never lingers as a nag on an expired fund —
    // the «ارتقاء صندوق» upsell covers that case.
    if (!isManager || servicePackage !== PLAN_SUBSCRIPTION) return null
    if (typeof remainingDays !== 'number') return null
    if (remainingDays <= 0 || remainingDays > WARN_FROM_DAYS) return null

    return (
        <div className="mx-4 mb-[18px] rounded-[8px] border border-[#FFD79A] bg-[#FFF7E8] px-3 py-3">
            <p className="text-sm font-bold text-[#8A5A00]">
                بسته‌ی صندوق {faPlain.format(remainingDays)} روز دیگر تمام
                می‌شود
            </p>
            <p className="mt-1 text-xs leading-5 text-[#8A5A00]">
                همین حالا می‌توانید تمدید کنید؛ روزهای باقی‌مانده از دست نمی‌رود
                و به دوره‌ی تازه اضافه می‌شود.
            </p>
            <button
                type="button"
                className="mt-3 h-[31px] w-full rounded-[4px] bg-green-1 text-sm font-bold text-white active:scale-[0.98]"
                onClick={() =>
                    navigate(`/fund/plans/subscription/${moneyPoolId}`)
                }
            >
                تمدید اشتراک
            </button>
        </div>
    )
}
